import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTheme, styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Grid, Stack, Typography, Link, useMediaQuery, Box } from '@mui/material';
import AuthCardWrapper from 'components/Cards/AuthCardWrapper';
import logoImg from 'assets/images/LargeWakeSmart.JPG';
import ApiHelper from 'utils/apiHelper';

const AuthWrapper = styled('div')(({ theme }) => ({
    background: `linear-gradient(white, ${theme.palette.primary.main})`
}));

const AccountValidation = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [queryParameters] = useSearchParams();
    const [validating, setValidating] = useState(true);
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        handleAccountValidate();
    });

    const handleAccountValidate = () => {
        ApiHelper.post(
            '/api/auth/validate_account/',
            {
                uid: queryParameters.get('uid'),
                token: queryParameters.get('token')
            },
            {},
            {},
            false
        )
            .then(() => {
                setValidating(false);
                toast.success('Your account was successfully validated, you can login now');
                navigate('/login');
            })
            .catch((err) => {
                if (err.response.data.message) {
                    toast.error(`Failed! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to validate your account');
                }
                setValidating(false);
            });
    };

    return (
        <AuthWrapper>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item sx={{ mb: 3 }}>
                                        <Link href="/">
                                            <img src={logoImg} width="150" alt="" />
                                        </Link>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction={matchDownSM ? 'column-reverse' : 'row'}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item>
                                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                    <Typography
                                                        color={theme.palette.primary.main}
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h3' : 'h2'}
                                                        sx={{ textAlign: 'center' }}
                                                    >
                                                        Validating your account, please wait...
                                                    </Typography>
                                                    <Box sx={{ mt: 2 }}>{validating && <CircularProgress />}</Box>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
};

export default AccountValidation;
